export enum SentEnvelopeStatus {
    pending = 1,
    completed = 2,
    expired = 3,
    rejected = 4,
    deleted = 5,
    reproved = 6,
    onApproval = 7,
    toFill = 8
}
